<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal title="跟进记录" :width="1200" :open="true" :confirmLoading="state.loading" :maskClosable="false"
        @ok="onFormSubmit" @cancel="cancel" :footer="null">
        <a-card :bordered="false">
            <div class="table-page-search-wrapper">
                <a-form>
                    <a-row :gutter="48">
                        <a-col :md="6" :sm="24">
                            <a-form-item label="昵称">
                                <a-input v-model:value="queryParam.nickname" placeholder="请输入"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="步骤" name="step">
                                <a-select mode="multiple" v-model:value="queryParam.step" placeholder="请选择">
                                    <a-select-option :value="1">线索</a-select-option>
                                    <a-select-option :value="2">待办</a-select-option>
                                    <a-select-option :value="3">办理中</a-select-option>
                                    <a-select-option :value="4">已办结</a-select-option>
                                    <a-select-option :value="5">已废弃</a-select-option>
                                    <a-select-option :value="6">公共池</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="创建时间">
                                <BetweenTimePick v-model:value="queryParam.between_time"></BetweenTimePick>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="内容">
                                <a-input v-model:value="queryParam.record" placeholder="内容"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <span class="table-page-search-submitButtons">
                                <a-button type="primary" @click="loadData">查询</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
            <a-table :columns="columns" :loading="state.loading" :data-source="dataSource" :pagination="pagination"
                @change="onChange" rowKey="id">
                <template #bodyCell="{ column, record, index, text }">
                    <template v-if="column.dataIndex === 'nickname'">
                        {{ text }}
                    </template>
                    <template v-if="column.dataIndex == 'step_name'">
                        <a-tag v-if="record.step == 1" color="green">{{ text }}</a-tag>
                        <a-tag v-else-if="record.step == 2" color="blue">{{ text }}</a-tag>
                        <a-tag v-else-if="record.step == 3" color="red">{{ text }}</a-tag>
                        <a-tag v-else-if="record.step == 4" color="cyan">{{ text }}</a-tag>
                        <a-tag v-else-if="record.step == 5" color="gray">{{ text }}</a-tag>
                        <a-tag v-else-if="record.step == 6">{{ text }}</a-tag>
                        <a-tag v-else>{{ text }}</a-tag>
                    </template>
                    <template v-else-if="column.dataIndex === 'operate'">
                        <a @click="handleEdit(record)">编辑</a>
                    </template>
                </template>
            </a-table>
            <createRecord v-if="state.showCreate" @cancel="handleCancel" @ok="handleOk" :detailData="state.detailData">
            </createRecord>
        </a-card>
    </a-modal>
</template>
<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed, handleError } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import type { PaginationProps } from 'ant-design-vue'
import BetweenTimePick from '@/components/base/BetweenTimePick.vue'
import createRecord from './createRecord.vue'
const emit = defineEmits(['ok', 'cancel'])
const props = defineProps({
    detailData: {
        type: Object,
        default: () => null
    }
})
const columns = [
    {
        title: '昵称',
        dataIndex: 'nickname',
        width: 200
    },
    {
        title: '微信号',
        dataIndex: 'wxid',
        width: 150
    },
    {
        title: '步骤',
        dataIndex: 'step_name',
        width: 200
    },
    {
        title: '记录内容',
        dataIndex: 'record',
    },
    {
        title: '时间',
        dataIndex: 'created_at',
        width: 200
    },
    {
        title: '操作',
        dataIndex: 'operate',
        width: 100
    }
]
interface state {
    loading: boolean
    showCreate: boolean
    detailData: object
}
const state = reactive<state>({
    loading: false,
    showCreate: false,
    detailData: {},
})
let queryParam = reactive<any>({
})
let dataSource = ref([])
const pagination = reactive<PaginationProps>({
    pageSize: 10,
    pageSizeOptions: ['10', '50', '100', '200', '1000', '2000'],
    current: 1,
    total: undefined,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `总数：${total}`
})
onMounted(() => {
    loadData()
})
const loadData = () => {
    state.loading = true
    let su_id = props.detailData ? props.detailData.id : 0
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/xiansuo/recordList',
        method: 'post',
        data: Object.assign({ page: pagination.current, limit: pagination.pageSize, su_id: su_id }, queryParam)
    }
    baseService(requestParam).then((res) => {
        state.loading = false
        pagination.total = res.data.total_records
        dataSource.value = res.data.list.map((item) => ({ ...item, isDetail: false }))
    })
}
const onChange = (val) => {
    pagination.pageSize = val.pageSize
    pagination.current = val.current
    loadData()
}
const onFormSubmit = () => {
    emit('cancel')
}
const cancel = () => {
    emit('cancel')
}
const handleEdit = (record) => {
    state.detailData = record
    state.showCreate = true
}
const handleOk = () => {
    state.showCreate = false
    loadData()
}
const handleCancel = () => {
    state.showCreate = false
}
</script>
<style lang="less" scoped></style>
